import React, { useEffect, useState } from "react";
import cx from "../Portal.module.css";
import { Row, Col, NavLink } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { AiFillPlusCircle } from "react-icons/ai";
import { compressImage } from "../../utils/CommonFunctions";
import CircularProgress from "@mui/material/CircularProgress";
import { httpPortal } from "../../Apis/commonApis";
import { useDispatch } from "react-redux";
import { clearPortalRefreshToken } from "../../redux-toolkit/reducer/portalRefreshToken_reducer";

const redirectUrl = process.env.REACT_APP_REDIRECTION_URL_PLAN;

export default function PortalHeader() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [portalData, setportalData] = useState(null);
  const [careHome, setCareHome] = useState("");
  const [imgLoader, setImgLoader] = useState(false);

  useEffect(() => {
    const fandfData = localStorage.getItem("fandfData");
    const fandftoken = localStorage.getItem("fandfam_token");
    let careSite = localStorage.getItem("careSite");
    console.log(fandfData, "fandfData");
    console.log(fandftoken, "fandftoken");
    console.log(careSite, "careSite");
    const isLsUndefined =
      fandfData === "undefined" ||
      fandftoken === "undefined" ||
      careSite === "undefined" ||
      fandfData === "null" ||
      fandftoken === "null" ||
      careSite === "null";
    const parsedCaresiteData = safeJsonParse(careSite);
    const parsedfandfData = safeJsonParse(fandfData);
    console.log(isLsUndefined, "isLsUndefined-------");
    if (isLsUndefined || !parsedCaresiteData || !parsedfandfData) {
      redireUrl("clearAll");
    } else {
      setportalData(parsedfandfData);
      setCareHome(parsedCaresiteData);
    }
  }, []);

  const safeJsonParse = (value) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error("Invalid JSON:", error);
      return null;
    }
  };

  let redireUrl = (type) => {
    console.log(type, "redireUrl function----------");
    if (type == "profile") {
      history.push(`/portal/userProfile`, { replace: false });
    } else if (type == "reqService") {
      history.push(`/portal/requestService`, { replace: false });
    } else if (type == "changePwd") {
      history.push(`/portal/changePassword`, { replace: false });
    } else if (type == "changeSecQue") {
      history.push({
        pathname: `/portal/createPortalPassword`,
        state: { SecurityQuestion: "SecurityQuestion" },
      });
    } else if (type == "feedback") {
      history.push(`/portal/Feedback`, { replace: false });
    } else {
      localStorage.removeItem("fandfData");
      localStorage.removeItem("fandfam_token");
      localStorage.removeItem("careSite");
      history.push(`/portal/login`, { replace: true });
    }
  };

  async function verifyLogout() {
    const response = await httpPortal("logout", "post");
    // Clear refresh tokens from Redux store and localStorage
    dispatch(clearPortalRefreshToken());

    // Clear other tokens from localStorage
    localStorage.removeItem("fandfData");
    localStorage.removeItem("fandfam_token");
    localStorage.removeItem("careSite");

    // Redirect to login page
    history.replace("/portal/login");
  }

  async function onFileChange(e) {
    let profileImg = e.target.files;
    if (profileImg) {
      setImgLoader(true);
      let compressedImg = await compressImage(profileImg);
      editImage(compressedImg);
    }
  }

  const editImage = async (imgg) => {
    let body = new FormData();
    body.append("image", imgg);
    body.append("fandfMemberId", portalData?._id);
    body.append("clientId", portalData.clientId);
    const res = await httpPortal(`editFanFmember`, "post", body, "formdata");
    if (res.status) {
      let keyUser = res.data?.keycontact.find(
        (item) => item._id === portalData?._id
      );
      localStorage.setItem("fandfData", JSON.stringify(keyUser));
      setportalData(keyUser);
    }
    setImgLoader(false);
  };

  return (
    <>
      <div className={`${cx.headerStart}`}>
        <div className={`container`}>
          <div className={`${cx.headerPortalFLex}`}>
            <a href={redirectUrl} className="d-inline-flex">
              <img
                className={`${cx.logoImgPortal}`}
                src="/admin/images/Newfooter_Logo.svg"
                alt="logo"
              />
            </a>
            <div className={`${cx.headerTop}`}>
              <h5>Friends & Family Portal</h5>
            </div>
            {portalData && (
              <div className={`${cx.userDropdownPortal}`}>
                <div className={`dropdown`}>
                  <button
                    className={`btn btn-secondary dropdown-toggle`}
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {careHome?.careSiteName}
                    <img
                      src={portalData?.image ?? "/admin/images/chatUser.svg"}
                      alt=""
                      className={portalData?.image ? "" : "forImagefandsfam"}
                    />
                  </button>
                  <ul
                    className={`dropdown-menu`}
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <div className={`${cx.userImages}`}>
                        <div className="position-relative">
                          {imgLoader ? (
                            <div>
                              <CircularProgress color="secondary" />
                            </div>
                          ) : (
                            <img
                              src={
                                portalData?.image ??
                                "/admin/images/chatUser.svg"
                              }
                              alt=""
                              className={
                                portalData?.image ? "" : "forImagefandsfam"
                              }
                            />
                          )}
                          <div className={`${cx.editProfile_imgicon}`}>
                            <input
                              type="file"
                              id="upLoader"
                              accept="image/*"
                              name="images"
                              onChange={onFileChange}
                            />
                            <span>
                              <AiFillPlusCircle className="edit_icon" />
                            </span>
                          </div>
                        </div>
                        <h3> {portalData?.name}</h3>
                        <p>{portalData?.email}</p>
                      </div>
                    </li>
                    <li>
                      <NavLink
                        className={`dropdown-item`}
                        to="#"
                        onClick={(e) => redireUrl("profile")}
                      >
                        My profile
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`dropdown-item`}
                        to="#"
                        onClick={(e) => redireUrl("reqService")}
                      >
                        Request Service
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`dropdown-item`}
                        to="#"
                        onClick={(e) => redireUrl("changePwd")}
                      >
                        Change Password
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`dropdown-item`}
                        to="#"
                        onClick={(e) => redireUrl("changeSecQue")}
                      >
                        Change Security Question
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`dropdown-item`}
                        to="#"
                        onClick={(e) => redireUrl("feedback")}
                      >
                        Feedback
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`dropdown-item`}
                        to="#"
                        onClick={() => verifyLogout()}
                      >
                        Logout
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={`${cx.headerHeight_portal}`}></div>
    </>
  );
}
